import React from 'react'
import { ListItemButton as MuiListItemButton, ListItemButtonProps } from '@mui/material'

interface PropsType extends ListItemButtonProps {}

export const ListItemButton = (props: PropsType) => {
	return <MuiListItemButton {...props}>{props.children}</MuiListItemButton>
}
